(function () {
	const _button = document.getElementById('event-apply-button');
	const _form = document.getElementById('event-application-form');
	
	if (!_form) {
		return;
	}
	
	_button.addEventListener('click', () => {
		util.toggleClass(_button, 'is-highlighted');
		util.toggleClass(_form, 'is-visible');
		
		if (util.hasClass(_form, 'is-visible')) {
			_form.querySelector('input').focus();
		}
	});
	
	new FormValidator(_form, {
		errorMode: 'alert',
		submitText: 'Feldolgozás...',
	});
}());